// extracted by mini-css-extract-plugin
export var link = "_tu-0";